import Vue from 'vue'
import Vuex from 'vuex'
import constants from './modules/constants'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        constants
    },
    getters: {

    },
    mutations: {

    },
    strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js